import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import Image from 'next/image';
import CoorpLayout, {
  Title,
  Text,
  SubTitle,
} from '@/components/layout/CoorpLayout';
import inspection from '~/images/premium-inspection/premium_inspection.png';

export default function PremiumInspectionPage() {
  const { t } = useTranslation();
  // TODO: add separate translation strings for each of the list items

  const ts = t('products:CORPORATE_PREMIUM_INSPECTION_ITEM_1_TEXT');
  return (
    <CoorpLayout
      headingOne={t('products:CORPORATE_PREMIUM_INSPECTION_H1')}
      headingTwo={t('products:CORPORATE_PREMIUM_INSPECTION_H2')}
      headingThree={t('products:CORPORATE_PREMIUM_INSPECTION_H3_HERO')}
      breadcrubPages={[
        {
          name: t('products:CORPORATE_PREMIUM_INSPECTION_H1'),
          href: '/premium-inspection',
        },
      ]}
    >
      <Title title={t('products:CORPORATE_PREMIUM_INSPECTION_H3_TITLE')} />
      <Text text={t('products:CORPORATE_PREMIUM_INSPECTION_P1')} />
      <hr className='mt-8' />
      <div className='mt-4 grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-2'>
        <Image
          src={inspection}
          alt={t('products:CORPORATE_PREMIUM_INSPECTION_H3_TITLE')}
          objectFit='contain'
        />
        <div className='mt-4 md:mt-9'>
          <SubTitle title={t('products:CORPORATE_PREMIUM_INSPECTION_H1')} />
          <div
            className='list-inside pb-8 child:ml-4 child:list-disc'
            dangerouslySetInnerHTML={{
              __html: ts,
            }}
          />
        </div>
      </div>
    </CoorpLayout>
  );
}
